<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="项目名"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="fromSets" highlight-current-row v-loading="listLoading"  style="width: 100%;" border :height="formHeight" size="mini">
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="projectName" label="项目名" sortable min-width="100">
			</el-table-column>
			<el-table-column prop="factorNames" label="因子">
			</el-table-column>
			<el-table-column label="操作" min-width="200px">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-delete-button  @select-type="handleDel(scope.$index, scope.row)" ></table-delete-button>
				</template>
			</el-table-column>
		</el-table>


		<!--Form界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formSet" label-width="120px"  ref="formSet">
				<el-form-item label="项目名称" prop="projectId" >
					<el-select v-model="formSet.projectIds" placeholder="请选择项目" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="报表因子" prop="factor">
					<el-checkbox-group v-model="formSet.keys">
						<el-checkbox v-for="item in factors" :label="item.keyword" :key="item.keyword">
							{{item.name}}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
		    <div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getFormSetList,getRoles,deleteFormSet,addAndUpdateFormSet,getProjects,getFactors} from '../../api/api';

	import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'
	import TableDeleteButton from '../../components/myButton/TableDeleteButton.vue'
	import DropButton from '../../components/myButton/DropButton.vue'

	export default {
	components: { myButton,TableUpdateButton,TableDeleteButton,DropButton},
		data() {
			return {
				filters: {
					name: ''
				},
				fromSets: [],
                projects:[],
                factors:[],
				listLoading: false,
				sels: [],//列表选中列
				type:'新增',

				formVisible: false,//修改界面是否显示
				loading: false,
				formHeight:0,
				//修改界面数据
				formSet: {
                    id:0,
                    keys:[],
                    projectId:''
				}

			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getFormSets();
				}else if(type=="add"){
					this.handleAdd();
				}
			},
            //查询项目信息
			getProjects() {
                if(this.projects.length>0){
                    return;
                }
				getProjects().then((res) => {
					this.projects = res.data;
				});
            },
            getFactors(){
                if(this.factors.length>0){
                    return;
                }
                getFactors().then((res) => {
					this.factors = res.data;
					console.log(this.factors)
				});
            },
			//获取列表
			getFormSets() {
				let para = {
					name: this.filters.name
				};
				this.listLoading = true;
				getFormSetList(para).then((res) => {
					this.listLoading = false;
					
					this.fromSets = res.data.data;
				});
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					var param=new  URLSearchParams();
					param.append("projectId",row.projectIds);

					deleteFormSet(param).then((res) => {
						this.listLoading = false;
						let resData = res.data;
						if (resData.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
						}else{
							this.$message({
								message: '操作失败',
								type: 'error'
							})
						}
						this.getFormSets();
					});
				}).catch(() => {

				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.formVisible = true;
                this.type='修改';
                this.getProjects();
                this.getFactors();
                this.formSet.keys=[];
				this.formSet.projectId=row.projectIds;

                var arr=row.keyWords.split(',');
                arr.forEach(element => {
                    this.formSet.keys.push(element);
                });
			},
			//显示新增界面
			handleAdd: function () {
				this.formVisible = true;
                this.type='新增';
                this.getProjects();
                this.getFactors();
				this.formSet = {
                    id:0,
                    keys:[],
                    projectId:''
				}
			},
			//Form表单提交
            submitData:function(){
                if(this.formSet.keys.length==0){
                    this.$message({
                        message: "请选择因子",
                        type: 'error'
                    })
                    return;
                }

				this.editSubmit();
            },
			//修改
			editSubmit: function () {
                this.$confirm('确认提交吗？', '提示', {}).then(() => {
                    this.loading = true;

					var param=new  URLSearchParams();
					param.append("keys",this.formSet.keys);
					param.append("projectId",this.formSet.projectId);

                    addAndUpdateFormSet(param).then((res) => {
                        this.loading = false;
                        let resData = res.data;
                        if (resData.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
						}else{
							this.$message({
								message: '操作失败',
								type: 'error'
							})
						}
                        this.formVisible = false;
                        this.getFormSets();
                    });
                });
			},
			 //取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
				this.permissionVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getFormSets();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// formFactor.vue?69f98f83